import { render, staticRenderFns } from "./breaking-changes.vue?vue&type=template&id=60c11936&scoped=true&lang=html&"
import script from "./breaking-changes.vue?vue&type=script&lang=js&"
export * from "./breaking-changes.vue?vue&type=script&lang=js&"
import style0 from "./breaking-changes.vue?vue&type=style&index=0&id=60c11936&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c11936",
  null
  
)

component.options.__file = "breaking-changes.vue"
export default component.exports